import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'BuildingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 21l18 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9 8l1 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9 12l1 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9 16l1 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 8l1 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 12l1 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 16l1 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16"
    }, null), _createTextVNode(" ")]);
  }
};